import React, {useState, useEffect} from 'react';
import { Link } from 'react-router-dom';

import httpClient from '../fetch/fetch';
import moment from 'moment/moment';
import Select from "react-select"

import {toast} from "react-toastify"

import 'moment/locale/es';
import { Pagination } from './helpers/Pagination';
import Loader from './helpers/Loader';
moment.locale('es');

function List() {

    const [loading, setloading] = useState(true);
    const [search, setsearch]   = useState(true);

    const [page, setpage] = useState("1");
    const [data, setdata] = useState([]);

    const [filterByState, setfilterByState] = useState({label: "Listar TODOS los eventos", value: 2});

    const getdata = (paged = page, activo = filterByState.value) => {
        console.log('search');
        setloading(true);
        setpage(paged);

        httpClient.get(`api/Evento/ListarEventos/${paged}/${activo}`)
        .then((res) => {
            console.log(res.data);

            if(res.status = 200){
                setdata(res.data);
                setloading(false);
            }

        }).catch((err) => {
            setloading(false);
        });
    }

    useEffect(() => {
      if(loading){
        if(search){
            document.title = 'Listado de eventos';
            setsearch(false);
            getdata();
        }
      }
    }, []);

    const handleFilterByState = (paged = "1") => {
        getdata(paged, filterByState.value);
    }

    return (
        <div>
            <header>
                <div className="container text-center">
                <div className="row justify-content-center">
                    <div className="col-lg-6 col-sm-8 col-10">
                    <img 
                        src="https://recursos.exportemos.pe/evento/logo-app-exportemos.png" 
                        alt="" 
                        title="Eventos exportemos.pe v.0.0"
                        className="img-fluid"
                    />
                    </div>
                </div>
                </div>
            </header>
        
            <section>
                <div className="content">
                    <div className="container">
                        <div className="row justify-content-center vh-75 align-items-center py-5">
                            <div className="col-lg-12">
                                <h2 className='h3 mb-3 fw-bold'>
                                    Listado de eventos
                                </h2>

                                <div className="card shadow w-100">
                                    <div className="card-body">
                                        <div className="py-4">

                                            <div className="filter mb-4">
                                                <div className="row align-items-center">
                                                    <div className="col-lg-1">
                                                        <label htmlFor="" className='mb-0 fw-bold'>
                                                            Estado : 
                                                        </label>
                                                    </div>
                                                    <div className="col-lg-4 f-normal">
                                                        <Select 
                                                            placeholder="Seleccione un estado"
                                                            options={[
                                                                {label: "Listar eventos inactivos", value: 0},
                                                                {label: "Listar eventos activos",   value: 1},
                                                                {label: "Listar TODOS los eventos", value: 2}
                                                            ]}
                                                            onChange={(val) => setfilterByState(val)}
                                                            value={filterByState}
                                                        />
                                                    </div>
                                                    <div className="col-lg-2 f-normal">
                                                        <button 
                                                            onClick={() => handleFilterByState()} 
                                                            className='btn btn-primary w-100 fw-bold'
                                                        >
                                                            <i className="fa-solid fa-magnifying-glass me-2"></i>
                                                            Consultar
                                                        </button>
                                                    </div>
                                                    <div className="col-lg-3"></div>
                                                    <div className="col-lg-2">
                                                        <Link 
                                                            // onClick={() => handleFilterByState()} 
                                                            to={'/crear-evento'}
                                                            className='btn btn-primary w-100 fw-bold'
                                                        >
                                                            <i className="fa-solid fa-plus me-2"></i>
                                                            Crear evento
                                                        </Link>
                                                    </div>
                                                </div>
                                            </div>
                                            
                                            <div className="table-responsive mb-3">
                                                <table className='table table-bordered table-hover table-striped'>
                                                    <thead>
                                                        <tr>
                                                            <th style={{ width: '50px'}}>#</th>
                                                            <th style={{ width: '270px'}}>Nombre</th>
                                                            <th style={{ width: '120px'}}>Fecha inicio</th>
                                                            <th style={{ width: '120px'}}>Fecha fin</th>

                                                            <th>Enlace para registro</th>
                                                            <th>Estado</th>
                                                            <th style={{ width: '150px'}}></th>
                                                            <th style={{ width: '50px'}}></th>
                                                        </tr>
                                                    </thead>
                                                    {!loading &&
                                                        <tbody>
                                                            {data.length > 0 && data.map((item, key) => {
                                                                let codigo = item.even_Codigo;
                                                                
                                                                return (
                                                                    <tr key={key}>
                                                                        <td className='text-primary fw-bold'>
                                                                            {(key + 1) + ((page - 1) * 10)}
                                                                        </td>
                                                                        <td>{item.even_Nombre}</td>
                                                                        <td>{moment(item.even_FechaInicio).format("DD-MM-yyyy")}</td>
                                                                        <td>{moment(item.even_FechaFin).format("DD-MM-yyyy")}</td>
                                                                        <td>
                                                                            <Link className='fw-bold' to={`/registro/${item.even_Url}`}>
                                                                                {item.even_Url}
                                                                            </Link>
                                                                        </td>
                                                                        <td className='text-center text-primary'>
                                                                            {item.even_Activo ?
                                                                                <i className="fa-solid fa-eye"></i>
                                                                            :
                                                                                <i className="fa-solid fa-eye-slash"></i>
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            <Link to={`/detalle/${codigo}`} className='btn btn-sm btn-light fw-bold border-dark'>
                                                                                ver más detalles
                                                                            </Link>
                                                                        </td>
                                                                        <td>
                                                                            <Link to={`/editar-evento/${codigo}`} className='btn btn-sm btn-light fw-bold border-dark'>
                                                                                <i className="fa-solid fa-pencil"></i>
                                                                            </Link>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })}

                                                            {data.length === 0 &&
                                                                <tr>
                                                                    <td className='text-center' colSpan={10}>
                                                                        No se han encontrado resultados
                                                                    </td>
                                                                </tr>
                                                            }
                                                        </tbody>
                                                    }
                                                </table>
                                            </div>

                                            {loading &&
                                                <Loader />
                                            }

                                            {data.length > 0 && !loading &&
                                                <Pagination
                                                    data={data}
                                                    pagina={page}
                                                    changePage={(page) => handleFilterByState(page)}
                                                />
                                            }
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    )

}

export default List